import { useMemo } from "react";
import { filterCategories } from "@/lib/constants/drivers.constants";
import type { TFilters } from "@/types";
import type { TFilterCategory } from "@/components";
import { t } from "@/utils";

type FilterResultsTitleProps = {
	readonly results: any[];
	readonly filters: TFilters;
};

/**
 * Displays a text with the number of filtered results
 * ex: "123 result in all categories"
 * @constructor
 */
export default function FilterResultsTitle({
	filters,
	results,
}: FilterResultsTitleProps) {
	// Get the active category name

	// If we allow only the predefined categories to be displayed, then uncomment the code below
	/* const category = useMemo(() => {
		if (filters.category?.[0]) {
			const categoryObject = filterCategories.find(
				(cf: TFilterCategory) => cf.id === filters.category[0]
			);
			return categoryObject?.label;
		}
	}, [filters.category]); */

	return (
		<p
			className="hmc-title-xs pb-5 text-systemInfo"
			data-testid="filter-results"
		>
			{results.length === 1
				? `1 ${t("filters.result")}`
				: `${results.length} ${t("filters.results")}`}
			<span className="text-contentSubtle">
				&nbsp;
				{filters.category
					? t("filters.results-category", { category: filters.category[0] })
					: t("filters.results-all-category")}
			</span>
		</p>
	);
}
